import React from 'react';
import {
  FormikDropdownField,
  FormikDropdownOption,
} from 'lib/components/formik/FormikDropdown';
import { FontSizes } from '../../../constants';
import { FormSection } from './FormSection';

interface IFontSettingsProps {
  index?: number;
  allFontFamilyOptions: FormikDropdownOption[];
}

export const FontSettings = ({
  index,
  allFontFamilyOptions,
}: IFontSettingsProps) => {
  return (
    <FormSection title='FONT'>
      <FormikDropdownField
        options={allFontFamilyOptions}
        name={`${`uiKits[${index}].fontFamily`}`}
        creatable={false}
        placeholder='Font'
        label={'Select a Font'}
        isRequired={false}
        disabled={false}
        hideError
      />
      <FormikDropdownField
        options={FontSizes}
        name={`${`uiKits[${index}].titleFontSize`}`}
        creatable={false}
        placeholder='Contact Font Size'
        label='Contact Font Size'
        isRequired={false}
        disabled={false}
        extendStyles={{
          mainWrapper: {
            minWidth: '131px',
            width: '100%',
          },
          labelStyles: {
            fontSize: '14px',
          },
        }}
        hideError
      />
    </FormSection>
  );
};
